











import { Component, Vue } from "vue-property-decorator";
import { AuthStatusCpt } from "@/core/components";

@Component({
  components: {
    AuthStatusCpt,
  },
})
export default class HeaderCpt extends Vue {}
